import React, {Fragment, useState, useContext, useCallback} from 'react';
import {Button} from '@homeaway/react-buttons';
import {SVGIcon} from '@homeaway/react-svg';
import {TrackingContext} from '@homeaway/react-event-tracking';
import {CHEVRON_RIGHT__16} from '@homeaway/svg-defs';
import {MULTI_UNIT_BUTTON_CLICK} from '../utils/edap';
import MultiUnitListWrapper from '../MultiUnitListWrapper/MultiUnitListWrapper';

import './MultiUnitModal.less';

const MultiUnitModal = ({
    inputParams,
    listing,
    propertyName,
    currency,
    isMetric,
    isDatelessSearch,
    clientLogger,
    messages
}) => {
    const [isOpen, setIsOpen] = useState(false);
    const trackingContext = useContext(TrackingContext);

    const onModalOpen = useCallback(() => {
        trackingContext.trigger(MULTI_UNIT_BUTTON_CLICK, listing);
        setIsOpen(true);
    }, [trackingContext, listing]);

    const onModalClose = () => {
        setIsOpen(false);
    };

    return (
        <div className="MultiUnitModal">
            <Button
                label={
                    <Fragment>
                        {messages.multipleUnitsButtonLabel}
                        <SVGIcon inlineFlex markup={CHEVRON_RIGHT__16} />
                    </Fragment>
                }
                size="xs"
                className="MultiUnit__modal-btn"
                onClick={onModalOpen}
            />
            {isOpen && (
                <Fragment>
                    <MultiUnitListWrapper
                        currency={currency}
                        inputParams={inputParams}
                        isMetric={isMetric}
                        isDatelessSearch={isDatelessSearch}
                        listing={listing}
                        propertyName={propertyName}
                        showDesktopView={false}
                        onModalClose={onModalClose}
                        isOpen={isOpen}
                        context={'modal'}
                        clientLogger={clientLogger}
                        messages={messages}
                    />
                </Fragment>
            )}
        </div>
    );
};

export default MultiUnitModal;
